import axios from 'axios'
import config from '../../shared/config'

export interface IUser {
  id: string
  email: string
}

/** Get the user info */
const getSelfInfo = async (accessToken: string): Promise<IUser> => {
  return axios
    .get(config.API_URL + '/api/v1/me/', {
      headers: { Authorization: `Bearer ${accessToken}` },
    })
    .then((r) => r.data)
}

const userApi = { getSelfInfo }

export default userApi
